import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Mail } from "lucide-react";
import { Modal, Spin } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import Globais from "../../components/Globais";
import { useMessage } from "../../uteis/mensagens/useMessage";

// 🌈 Fundo padrão gradiente
const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: linear-gradient(135deg, #003644, #0096c7);
  padding: 6rem 1rem 2rem 1rem;

  @media (max-width: 768px) {
    padding: 5rem 1rem 2rem 1rem;
  }
`;

// 📦 Card do formulário
const FormWrapper = styled.div`
  background: #fff;
  width: 100%;
  max-width: 450px;
  border-radius: 16px;
  padding: 2rem 2.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.4s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(15px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const Title = styled.h2`
  text-align: center;
  color: #003644;
  font-weight: 600;
  margin-bottom: 0.8rem;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #555;
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
`;

const InputGroup = styled.div`
  position: relative;
  margin-bottom: 1.1rem;

  svg {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    color: #777;
  }

  input {
    width: 100%;
    padding: 0.8rem 0.8rem 0.8rem 2.5rem;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 1rem;
    outline: none;
    transition: border 0.2s, box-shadow 0.2s;

    &:focus {
      border-color: #0096c7;
      box-shadow: 0 0 0 2px rgba(0, 150, 199, 0.2);
    }
  }
`;

const Botao = styled.button`
  width: 100%;
  background: #0096c7;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  padding: 0.9rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 0.6rem;
  transition: background 0.3s;

  &:hover {
    background: #00b4d8;
  }

  &:disabled {
    background: #90e0ef;
    cursor: not-allowed;
  }
`;

const Links = styled.div`
  text-align: center;
  font-size: 0.9rem;
  margin-top: 1.5rem;

  a {
    color: #0096c7;
    text-decoration: none;
    font-weight: 500;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export default function ViewEsqueceuSenha() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const { showSuccess, showError, showWarning, contextHolder } = useMessage();

  const [cooldown, setCooldown] = useState(0);

  const RESET_LOCK_KEY = "resetPasswordLock";

const saveResetLock = (email: string, minutes: number) => {
  localStorage.setItem(
    RESET_LOCK_KEY,
    JSON.stringify({
      email,
      unlockAt: Date.now() + minutes * 60000,
    })
  );
};

const getResetLock = () => {
  try {
    const data = localStorage.getItem(RESET_LOCK_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

const clearResetLock = () => {
  localStorage.removeItem(RESET_LOCK_KEY);
};

const ACTIVATION_LOCK_KEY = "activationResendUnlock";

const getActivationLock = () => {
  try {
    const data = localStorage.getItem(ACTIVATION_LOCK_KEY);
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
};

const saveActivationLock = (email: string, unlockAt: number) => {
  localStorage.setItem(
    ACTIVATION_LOCK_KEY,
    JSON.stringify({ email, unlockAt })
  );
};

const clearActivationLock = () => {
  localStorage.removeItem(ACTIVATION_LOCK_KEY);
};
const formatSeconds = (total: number) => {
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};


  useEffect(() => {
  if (cooldown > 0) {
    const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
    return () => clearTimeout(timer);
  }
}, [cooldown]);

useEffect(() => {
  const lock = getResetLock();

  if (lock) {
    const remaining = Math.floor((lock.unlockAt - Date.now()) / 1000);
    if (remaining > 0) {
      setCooldown(remaining);
    } else {
      clearResetLock();
    }
  }
}, []);

const abrirConfirmacaoAtivacao = (email: string) => {
  Modal.confirm({
    title: "Conta não ativada",
    content:
      "Sua conta ainda não foi ativada. Deseja reenviar o e-mail de ativação?",
    okText: "Reenviar e-mail",
    cancelText: "Cancelar",

    onOk: async () => {
      try {
        await axios.post(
          `${Globais.DOMINIOBACK}/auth/resend-activation`,
          { email }
        );

        showSuccess(
          "Novo e-mail de ativação enviado! Verifique também sua caixa de spam."
        );
        return true;
      } catch (err: any) {
        const code = err.response?.data?.code;
        const msg = err.response?.data?.error;

        if (code === "REENVIO_BLOQUEADO") {
          const minutos = Number(msg.match(/\d+/)?.[0] || 10);
          const unlockAt = Date.now() + minutos * 60000;

          saveActivationLock(email, unlockAt);
          abrirModalAtivacao(email); // ⬅ agora sim entra no contador
        } else {
          showError(msg || "Erro ao reenviar o e-mail.");
        }

        return true;
      }
    },
  });
};




const abrirModalAtivacao = (email: string) => {
  let unlockAt: number;

  const existingLock = getActivationLock();

  if (existingLock && existingLock.unlockAt > Date.now()) {
    unlockAt = existingLock.unlockAt;
  } else {
    // fallback de segurança (ex: 10 min)
    unlockAt = Date.now() + 10 * 60 * 1000;
    saveActivationLock(email, unlockAt);
  }

  const calcSeconds = () =>
    Math.max(0, Math.floor((unlockAt - Date.now()) / 1000));

  let remainingSeconds = calcSeconds();

  const modal = Modal.confirm({
    title: "Conta não ativada",
    content: `Você poderá reenviar o e-mail de ativação em ${formatSeconds(
      remainingSeconds
    )}.`,
    okText: formatSeconds(remainingSeconds),
    cancelText: "Cancelar",
    okButtonProps: { disabled: true },

    onCancel: () => {
      // Fecha o modal, mas mantém o bloqueio
    },
  });

  const interval = setInterval(() => {
    remainingSeconds = calcSeconds();

    modal.update({
      content: `Você poderá reenviar o e-mail de ativação em ${formatSeconds(
        remainingSeconds
      )}.`,
      okText: formatSeconds(remainingSeconds),
    });

    if (remainingSeconds <= 0) {
      clearInterval(interval);
      clearActivationLock();

      modal.update({
        content: "Agora você pode reenviar o e-mail de ativação.",
        okText: "Reenviar agora",
        okButtonProps: { disabled: false },
        onOk: async () => {
          try {
            await axios.post(
              `${Globais.DOMINIOBACK}/auth/resend-activation`,
              { email }
            );
            showSuccess("Novo e-mail de ativação enviado!");
          } catch (err: any) {
            const code = err.response?.data?.code;
            const msg = err.response?.data?.error;

            if (code === "REENVIO_BLOQUEADO") {
              const minutos = Number(msg.match(/\d+/)?.[0] || 10);
              const newUnlockAt = Date.now() + minutos * 60000;
              saveActivationLock(email, newUnlockAt);
              abrirModalAtivacao(email);
            } else {
              showError(msg || "Erro ao reenviar o e-mail.");
            }
          }
        },
      });
    }
  }, 1000);
};


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      showWarning("Por favor, insira um e-mail válido.");
      return;
    }
    if (cooldown > 0) {
    showWarning(`Aguarde ${cooldown}s para reenviar.`);
    return;
  }

    setIsLoading(true);

    try {
      const response = await axios.post(`${Globais.DOMINIOBACK}/auth/esquecisenha`, { email });

      // Sempre 200 (mesmo se e-mail não existir)
      showSuccess(response.data.message || "Se o e-mail estiver cadastrado, você receberá instruções.");
          // backend → 5 minutos (exemplo)
      saveResetLock(email, 5);
      setCooldown(5 * 60);
      setTimeout(() => navigate("/login"), 3000);
    } catch (error: any) {
      const code = error.response?.data?.code;
    const msg = error.response?.data?.error;

    if (code === "REENVIO_BLOQUEADO") {
      const minutos = Number(msg.match(/\d+/)?.[0] || 1);
      saveResetLock(email, minutos);
      setCooldown(minutos * 60);
      showWarning(msg);
    } else if (code === "CONTA_NAO_ATIVADA") {
      const lock = getActivationLock();

      if (lock && lock.unlockAt > Date.now()) {
        abrirModalAtivacao(lock.email);
      } else {
        abrirConfirmacaoAtivacao(email);
      }
    } else {
      showError(msg || "Erro ao processar solicitação.");
    }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container>
      {contextHolder}
      <FormWrapper>
        <form onSubmit={handleSubmit}>
          <Title>Esqueceu sua senha?</Title>
          <Subtitle>
            Não se preocupe! Informe seu e-mail e enviaremos instruções para
            redefinir sua senha.
          </Subtitle>

          <InputGroup>
            <Mail size={18} />
            <input
              type="email"
              id="email"
              required
              placeholder="Digite seu e-mail de cadastro"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </InputGroup>

          <Botao type="submit" disabled={isLoading || cooldown > 0}>
          {isLoading ? (
            <Spin size="small" />
          ) : cooldown > 0 ? (
            `Reenviar em ${cooldown}s`
          ) : (
            "Enviar e-mail"
          )}
        </Botao>

          <Links>
            <a href="/login">Voltar ao login</a>
          </Links>
        </form>
      </FormWrapper>
    </Container>
  );
}
